import { Component, Prop, Element, State, Event, EventEmitter, ComponentInterface, Watch } from '@stencil/core';
import { i18n } from '../../../utils/i18n';

@Component({
  tag: 'lar-translate',
  shadow: false
})
export class LarvaTranslate implements ComponentInterface {
  @Element() el!: HTMLElement;
  private i18n = i18n;

  @Prop() values: any;
  // input text
  @Prop() t: string = '';
  // faalback
  @Prop() fallback?: string | null;
  // translated (text
  @State() tt: string = '';
  @State() bindedListener: any;

  @Watch('t')
  changeHandler(): void {
    try {
    const exists = this.i18n.exists(this.t, { lng: this.i18n.language });
    const fallback = this.fallback ? this.fallback : this.t as string;
    this.tt = exists? this.i18n.t(this.t, { lng: this.i18n.language }) : fallback;
    } catch(err) {
      console.error(this.t);
      console.error(err);
    }
  }

  /**
   * Emitted when the value property has changed.
   */
  @Event() larlangchange!: EventEmitter<void>;

  componentWillLoad() {
    this.changeHandler();
    this.bindedListener = () => {
      this.larlangchange.emit();
      this.changeHandler();
    };
    this.i18n.on('languageChanged', this.bindedListener)
    this.i18n.on('languagechanged', this.bindedListener)
  }
  disconnectedCallback() {
    try {
      this.i18n.off('languageChanged', this.bindedListener);
      this.i18n.off('languagechanged', this.bindedListener);
    } catch (err) {
      console.error(err);
    }
  }

  private fillTranslationValues(translation: string = '', values?: { [key: string]: string }): string {
    if (!values) {
      return translation;
    }
    return translation.replace(/{\w+}/g, (key: string) => {
      const parsedKey: string = key.substring(1, key.length - 1);
      return (values[parsedKey] || 'undefined').toString();
    });
  }

  render() {
    return this.fillTranslationValues(this.tt, this.values);
  }

}
